export default __webpack_public_path__ + "static/media/baseline-battery_30-24px.a54c55af.svg";